export default "__VITE_ASSET__C96_lPb2__"